/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineCustomerService() {
        let customerService = {};
        customerService.getCompany = function (){
            return axios.get("/api/CustomerService/GetCompany");
        };
        customerService.getCompanyShippingAddresses = function (request){
            return axios.post("/api/CustomerService/GetCompanyShippingAddresses", request);
        };
        customerService.getCompanyBillingAddress = function (){
            return axios.get("/api/CustomerService/GetCompanyBillingAddress");
        };
        customerService.getCompanyAddress = function (companyAddressId) {
            return axios.get("/api/CustomerService/GetCompanyAddress?companyAddressId=" + companyAddressId);
        };
        customerService.getCompanyVehicles = function (request){
            return axios.post("/api/CustomerService/GetCompanyVehicles", request);
        };
        customerService.getPeopleToNotifyByCompanyVehicle = function (request){ 
            return axios.post("/api/CustomerService/GetPeopleToNotifyByCompanyVehicle", request);
        };
        customerService.getCompanyVehicle = function (vehicleId){
            return axios.get("/api/CustomerService/GetCompanyVehicle?vehicleId=" + vehicleId);
        };
        customerService.getPersonToNotifyRoles = function (){
            return axios.get("/api/CustomerService/GetPersonToNotifyRoles");
        };
        customerService.getCompanyVehiclesAssignedToUser = function (customerUserId){
            return axios.get("/api/CustomerService/GetCompanyVehiclesAssignedToUser?customerUserId=" + customerUserId);
        };
        customerService.addVehicleUsers = function (request){
            return axios.post("/api/CustomerService/AddVehicleUsers", request);
        };
        customerService.assignAndUnassignVehiclesFromCustomerUsers = function (request){
            return axios.post("/api/CustomerService/AssignAndUnassignVehiclesFromCustomerUsers", request);
        };
        customerService.markPersonToNotifyAsActiveOrInactive = function (request){
            return axios.post("/api/CustomerService/MarkPersonToNotifyAsActiveOrInactive", request);
        };
        customerService.markVehicleAsActiveOrInactive = function (request){
            return axios.post("/api/CustomerService/MarkVehicleAsActiveOrInactive", request);
        };
        customerService.addOrUpdateCustomerVehicle = function (request){
            return axios.post("/api/CustomerService/AddOrUpdateCustomerVehicle", request);
        };
        customerService.addOrUpdatePersonToNotifyForVehicle = function (request){
            return axios.post("/api/CustomerService/AddOrUpdatePersonToNotifyForVehicle", request);
        };
        customerService.sendEmailQueryToAdminUserOnBehalfOfCustomerUser = function (request){
            return axios.post("/api/CustomerService/SendEmailQueryToAdminUserOnBehalfOfCustomerUser", request);
        };
        return customerService;
    }
    //define globally if it doesn't already exist
    if (typeof (customerService) === "undefined") {
        window.customerService = defineCustomerService();
    } else {
        console.log("customerService already defined.");
    }
})(window);